import {
  type ReferralsResponse,
  ReferralsResponse as ReferralsResponseSchema,
} from '@uit/shared/schemas/referral';
import { Link } from 'react-router-dom';
import { useApi } from '../lib/api.js';
import s from './ReferralsPage.module.scss';

export function ReferralsPage() {
  const { data, error, loading } = useApi<ReferralsResponse>(
    '/api/referrals',
    ReferralsResponseSchema,
  );

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Referrals</h1>
        <p className={s.subtitle}>Each referrer vendor and the resources they referred.</p>
      </div>

      {error && <div className={s.error}>Failed to load referrals: {error.message}</div>}
      {!error && loading && !data && <div className={s.loading}>Loading referrals…</div>}

      {data && data.referrers.length === 0 && (
        <div className={s.empty}>
          No referrals yet. Mark a vendor as a referrer (on its detail page) or run the referral
          backfill, then capture the referrer when onboarding.
        </div>
      )}

      {data?.referrers.map((r) => (
        <section key={r.vendor_id} className={s.group}>
          <div className={s.groupHead}>
            <Link to={`/vendors/${r.vendor_id}`} className={s.referrerName}>
              {r.business_name}
            </Link>
            <span className={s.count}>
              {r.referred.length} referred resource{r.referred.length === 1 ? '' : 's'}
            </span>
          </div>
          <table className={s.table}>
            <thead>
              <tr>
                <th scope="col">Resource</th>
                <th scope="col">Vendor</th>
                <th scope="col">Client</th>
                <th scope="col">Engagement</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {r.referred.map((x) => (
                <tr key={x.engagement_id}>
                  <td>
                    <Link to={`/resources/${x.resource_id}`} className={s.nameLink}>
                      {x.resource_name}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/vendors/${x.vendor_id}`} className={s.nameLink}>
                      {x.business_name}
                    </Link>
                  </td>
                  <td>{x.client_name ?? <span className={s.muted}>—</span>}</td>
                  <td>
                    <Link to={`/engagements/${x.engagement_id}`} className={s.subLink}>
                      {x.product_service}
                    </Link>
                  </td>
                  <td>
                    <span className={s.badge}>{x.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  );
}
